module.exports = __webpack_public_path__ + "img/rup.8c8d8b8e.svg";